export default __webpack_public_path__ + "static/media/search-24px-hover.6d7f6af7.svg";